<template>
  <section>
    <PreloaderAnimation :class="{ 'translate-out': loaded }" />
    <div class="frame-box" v-if="!isLoading">
      <iframe
        @load="loaded = true"
        scrolling="yes"
        frameborder="0"
        :src="caseStudy.url"
      ></iframe>
    </div>
  </section>
</template>

<script>
import PreloaderAnimationVue from "../components/PreloaderAnimation.vue";
import { mapGetters } from "vuex";
export default {
  props: ["slug"],
  watch: {
    loaded() {
      setTimeout(() => {
        this.$destroy(PreloaderAnimationVue);
      }, 1000);
    },
    caseStudy(val) {
      if (!val) {
        return this.$router.push({ name: "Case Studies" });
      }
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      caseStudy: "caseStudies/caseStudy",
      isLoading: "caseStudies/isLoading"
    })
  },
  beforeMount() {
    this.$store.dispatch("caseStudies/getCaseStudy", this.slug);
  },
  metaInfo() {
    return {
      title: this.loaded
        ? `${this.caseStudy.name} | Shox Adomokai`
        : "Loading...",
      meta: [
        {
          property: "og:title",
          content: `${this.caseStudy.name} | Shox Adomokai`
        },
        {
          property: "twitter:title",
          content: `${this.caseStudy.name} | Shox Adomokai`
        },
        {
          property: "og:image",
          content: `${this.caseStudy.image}`
        },
        {
          property: "twitter:image",
          content: `${this.caseStudy.image}`
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.frame-box {
  background: white;
  position: relative;
  padding-top: 100px;
  min-height: calc(100vw - 100px);
  scrollbar-width: none;

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
    display: none;
  }

  iframe {
    position: fixed;
    height: 100%;
    width: 100%;
  }
}

.translate-out {
  animation: move 1s ease forwards;
  animation-delay: 0.3s;
  @keyframes move {
    to {
      transform: translateY(-100%);
    }
  }
}
</style>
